import type { ColorAdapted } from "~/common/interfaces/entities/color.interface";

export const getColorDefault = (): ColorAdapted => ({
	id: 0,
	hex: "#000000",
	name: "",
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	translations: []
});
